import React from 'react'
import classes from './HangingTitle.module.scss'
import EllipsisText from "react-ellipsis-text";

const HangingTitle = (props) => {
    return (
        <div className={props.type === 'idea' ? classes.TitleOverlay_container : classes.TitleOverlay_containerFnB}>
            <div className={classes.Title_container}>
                <div className={classes.TitlePipe_box}/>
                <span>
                    <EllipsisText text={props.title.replace(/(<([^>]+)>)/ig, "")} length={props.textLength ? props.textLength : 255}/>
                </span>
            </div>
            <div className={classes.TitleOverlay_box}/>
        </div>
    );
}

export default HangingTitle